import { ButtonProps } from '@ui/buttons/Button/types'

export type PayNowButtonProps = {
  price: number
} & Pick<
  ButtonProps,
  'label' | 'loading' | 'disabled' | 'width' | 'className' | 'onPress'
>
